<template>
  <form @submit.prevent="onSubmit" class="mt-4 classic-login">

    <slot name="classic-login-p-1-top"></slot>


    <h4 class="text-primary" v-t="'classic_login.title'"></h4>


    <div class="form-group mb-4 mt-3">
      <label for="username" v-t="'authentication_general.email_or_cellphone'"></label>
      <input dir="ltr" v-model="form.email" type="text"
             :placeholder="$t('authentication_general.email_or_cellphone_placeholder')"
             class="form-control rounded-pill text-left" id="username" aria-describedby="emailHelp">
      <form-errors-manager :validation="v$.form.email"/>
    </div>

    <div class="form-group mb-4">
      <label for="password" v-t="'authentication_general.password'"/>
      <m-password-form-input1 v-model="form.password"/>
      <form-errors-manager :validation="v$.form.password"/>
    </div>

    <div class="my-4">
      <m-captcha1 v-model="form.captcha_answer"/>
      <form-errors-manager :validation="v$.form.captcha_answer"/>
    </div>


    <button type="submit" class="mb-4 w-100 btn btn-primary rounded-pill btn-block" v-t="'classic_login.button_submit'">

    </button>
    <router-link :to="{ name: 'Register' }" class="text-primary mx-2 text-decoration-none"
                 v-t="'classic_login.register_link'">

    </router-link>

    <router-link
        :to="{ name: 'ForgetPassword' }"
        class="text-primary mx-2 my-3 d-block text-decoration-none" v-t="'classic_login.forget_password_link'">
    </router-link>

    <slot name="class-login-p-1-bottom"></slot>

  </form>
</template>

<script>
import {useVuelidate} from '@vuelidate/core'
import {minLength, required, email, requiredIf, or, maxLength} from "@vuelidate/validators";
import FormErrorsManager from "../../validator/FormErrorsManager";
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import mCaptcha1 from "../../Captcha/Captcha1";
import mPasswordFormInput1 from "../../Authentication/Component/Password/PasswordFormInput1.vue";
import {captchaValidation} from "../../Captcha/CaptchaValidation";

export default {
  name: "ClassicLogin",
  components: {FormErrorsManager, AuthenticationFormsContainer, mCaptcha1, mPasswordFormInput1},
  props: {
    redirect: {
      default: undefined
    }
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        captcha_answer: ''
      },
    };
  },
  validations() {
    return {
      form: {
        email: {
          required, emailOrPhone: or(phone, email),
        },
        password: {required, minLength: minLength(4)},
        captcha_answer: captchaValidation,
      },
    }
  },
  methods: {
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return

      const form = {
        ...this.form,
        withoutRedirect: this.redirect
      }
      this.$store.dispatch("Authentication/login", form).then(res => {

        this.$emit('login', true)

        document.querySelector('body').classList.remove('modal-open');

        document.querySelectorAll('.modal-backdrop').forEach(item => {
          item.classList.remove('modal-backdrop');
        })

      });
    },
  },
}
</script>

<style scoped>

</style>